<template>
  <section v-bind="$attrs" class="bg-gradient-to-r from-gray-900 to-gray-800 py-12">
    <div class="container">
      <div class="max-w-xl text-white">

        <Subnav
          v-if="subnav.length"
          :items="subnav"
          class="mb-8 -mt-2"
        />

        <div class="text-blue-500 mb-3 text-2xl">
          {{ label }}
        </div>

        <component class="text-3xl font-bold" :is="as">
          {{ headline }}
        </component>

        <slot name="default" />

      </div>
    </div>
  </section>
</template>

<script>
import Subnav from 'Web/Shared/Subnav.vue';

export default {
  inheritAttrs: false,
  components: {
    Subnav,
  },
  props: {
    as: {
      type: String,
      default: 'h1',
    },
    headline: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    subnav: {
      type: Array,
      default: () => [],
    },
  }
}
</script>
